export enum HotelNameSize {
  SMALL,
  VERY_SMALL,
  STANDARD,
  LARGE,
}
